// src/services/arquivoDigitalService.js
import api from './api';

export const listarArquivosDigitais = async () => {
  try {
    const response = await api.get('/arquivos-digitais');
    return response.data;
  } catch (error) {
    console.error('Erro ao listar arquivos digitais:', error);
    throw error;
  }
};

export const obterArquivoDigital = async (id) => {
  try {
    const response = await api.get(`/arquivos-digitais/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter arquivo digital:', error);
    throw error;
  }
};

export const obterMetadados = async (id) => {
  try {
    const response = await api.get(`/arquivos-digitais/${id}/metadados`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter metadados:', error);
    throw error;
  }
};

export const arquivarMonografia = async (dados) => {
  try {
    console.log(`Enviando requisição para arquivar monografia ${dados.monografiaId}`);
    console.log('Dados da requisição:', dados);
    
    const response = await api.post('/arquivos-digitais/arquivar-monografia', {
      // Campos básicos
      monografiaId: dados.monografiaId,
      palavrasChave: dados.palavrasChave,
      
      // Identificação do Autor
      nomeAutor: dados.nomeAutor,
      biAutor: dados.biAutor,
      telefoneAutor: dados.telefoneAutor,
      emailAutor: dados.emailAutor,
      
      // Afiliação
      supervisor: dados.supervisor,
      coSupervisor: dados.coSupervisor,
      
      // Informações Acadêmicas
      dataDefesa: dados.dataDefesa,
      areaConhecimento: dados.areaConhecimento,
      programa: dados.programa,
      tipoTitulacao: dados.tipoTitulacao,
      tipoMaterial: dados.tipoMaterial,
      
      // Direitos e Permissões
      aceiteDireitosAutorais: dados.aceiteDireitosAutorais,
      aceiteLicencaDistribuicao: dados.aceiteLicencaDistribuicao
    });
    
    console.log('Resposta do servidor:', response.data);
    console.log('Detalhes do arquivo criado:', response.data.arquivo);
    
    return response.data;
  } catch (error) {
    console.error('Erro ao arquivar monografia:', error);
    throw error;
  }
};

export const atualizarMetadados = async (id, dados) => {
  try {
    const response = await api.put(`/arquivos-digitais/${id}/metadados`, dados);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar metadados:', error);
    throw error;
  }
};




export const buscarArquivosDigitais = async (termo, instituicaoId) => {
  try {
    const params = new URLSearchParams();
    if (termo) params.append('termo', termo);
    if (instituicaoId) params.append('instituicao_id', instituicaoId);
    const query = params.toString();
    const url = `/arquivos-digitais/buscar${query ? `?${query}` : ''}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar arquivos digitais:', error);
    throw error;
  }
};

export const arquivarDocumentoPublico = async (formData) => {
    try {
      const response = await api.post('/arquivos-digitais/arquivar-publico', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao arquivar documento público:', error);
      throw error;
    }
  };